import { Typography } from "antd";

import { BlockContainer } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockContainer/BlockContainer";
import { BlockContent } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockContent/BlockContent";
import { BlockTitle } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockTitle/BlockTitle";
import {
    getJourneyNodeIcon,
    getJourneyNodeTypeConfig,
} from "Components/elements/RVFlow/Shared/JourneyNodePresentation";
import { NodeType } from "Types/Journey";

import { CustomAITaskFormItemKeys } from "../../../../Components/JourneyActionsPanel/NodeEditorPanel/Components/_DemoFormItems/constants";
import { useJourneyBlockData } from "../../Shared/Hooks/useJourneyBlockData/useJourneyBlockData";

import type { SharedBlockProps } from "Components/elements/RVFlow/RVFlowTypes";

import iconStyles from "./iconfix.module.scss";

const BLOCK_TITLE = "Regal AI Action";
const NODE_TITLE = "Custom AI Task";
const NODE_PROMPT = "Select AI Agent";

const BLOCK_VARIANT = getJourneyNodeTypeConfig(NodeType.DEMO_CustomTaskAI).variant;
const BLOCK_ICON = getJourneyNodeIcon(NodeType.DEMO_CustomTaskAI);

export function CustomAITaskBlock({ data, variant }: SharedBlockProps): JSX.Element {
    const { [CustomAITaskFormItemKeys.customAITaskName]: name } = data || {};

    const isNodeConfigured = !!name;

    const preferedNodeName = `${name}`;

    const { fallBackTitle, isActive, nodeName } = useJourneyBlockData({
        variant,
        isNodeConfigured,
        preferedNodeName,
        blockTitle: BLOCK_TITLE,
        nodeTitle: NODE_TITLE,
        nodePropmpt: NODE_PROMPT,
    });

    return (
        <BlockContainer iconClassName={iconStyles.outgoingFix} variant={BLOCK_VARIANT} icon={BLOCK_ICON}>
            <BlockTitle nodeData={data} fallBackDisplay={fallBackTitle}></BlockTitle>

            <BlockContent isActive={isActive}>
                <Typography.Text>{nodeName}</Typography.Text>
            </BlockContent>
        </BlockContainer>
    );
}
